import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createCapacidad } from '../api/capacidadFuncionalApi';

// ─── Funciones de puntuación individuales ────────────────────────────────────

export const calcularPiesJuntos = (t) => {
  const v = parseFloat(t);
  return !isNaN(v) && v >= 10 ? 1 : 0;
};

export const calcularSemitandem = (t) => {
  const v = parseFloat(t);
  return !isNaN(v) && v >= 10 ? 1 : 0;
};

export const calcularTandem = (t) => {
  const v = parseFloat(t);
  if (isNaN(v)) return 0;
  if (v >= 10) return 2;
  if (v >= 3) return 1;
  return 0;
};

export const calcularDesplazamiento = (tiempo) => {
  const t = parseFloat(tiempo);
  if (!t || isNaN(t)) return 0;
  if (t > 8.7) return 1;
  if (t >= 6.21) return 2;
  if (t >= 4.82) return 3;
  return 4;
};

export const calcularFuerza = (tiempo) => {
  const t = parseFloat(tiempo);
  if (!t || isNaN(t) || t >= 60) return 0;
  if (t > 16.7) return 1;
  if (t >= 13.7) return 2;
  if (t >= 11.2) return 3;
  return 4;
};

export const calcularEquilibrio = (piesJuntos, semitandem, tandem) =>
  calcularPiesJuntos(piesJuntos) + calcularSemitandem(semitandem) + calcularTandem(tandem);

// ─────────────────────────────────────────────────────────────────────────────

export const useCapacidadFuncionalForm = ({ idPaciente }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    tiempoPiesJuntos: '',
    tiempoSemitandem: '',
    tiempoTandem: '',
    tiempoDesplazamiento: '',
    tiempoSentadillas: '',
    tiempoTUG: '',
    falloEjecucion: false,
  });
  const [openGood, setOpenGood] = useState(false);
  const [openError, setOpenError] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const parsedValue =
      type !== 'checkbox' && typeof value === 'string' ? value.replace(/,/g, '.') : value;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : parsedValue,
    }));
  };

  const velocidadMarcha = useMemo(
    () =>
      formData.tiempoDesplazamiento
        ? (4 / parseFloat(formData.tiempoDesplazamiento)).toFixed(2)
        : '',
    [formData.tiempoDesplazamiento]
  );

  // Sub-puntuaciones individuales
  const ptPiesJuntos   = useMemo(() => calcularPiesJuntos(formData.tiempoPiesJuntos),   [formData.tiempoPiesJuntos]);
  const ptSemitandem   = useMemo(() => calcularSemitandem(formData.tiempoSemitandem),   [formData.tiempoSemitandem]);
  const ptTandem       = useMemo(() => calcularTandem(formData.tiempoTandem),            [formData.tiempoTandem]);
  const ptEquilibrio   = useMemo(() => ptPiesJuntos + ptSemitandem + ptTandem,           [ptPiesJuntos, ptSemitandem, ptTandem]);
  const ptDesplazamiento = useMemo(() => calcularDesplazamiento(formData.tiempoDesplazamiento), [formData.tiempoDesplazamiento]);
  const ptFuerza       = useMemo(() => calcularFuerza(formData.tiempoSentadillas),       [formData.tiempoSentadillas]);

  const sppbTotal = useMemo(
    () => ptEquilibrio + ptDesplazamiento + ptFuerza,
    [ptEquilibrio, ptDesplazamiento, ptFuerza]
  );

  const esFragilTUG = formData.tiempoTUG && parseFloat(formData.tiempoTUG) >= 12;

  const guardarDatos = async () => {
    try {
      await createCapacidad({
        pacienteId: idPaciente.toString(),
        userId: localStorage.getItem('id'),
        payload: { ...formData, velocidadMarcha, puntosSPPB: sppbTotal },
      });
      setOpenGood(true);
      setTimeout(() => navigate(`/paciente/${idPaciente}`), 1500);
    } catch (error) {
      console.error('Error al guardar capacidad funcional:', error);
      setOpenError(true);
    }
  };

  return {
    formData,
    velocidadMarcha,
    sppbTotal,
    ptPiesJuntos,
    ptSemitandem,
    ptTandem,
    ptEquilibrio,
    ptDesplazamiento,
    ptFuerza,
    esFragilTUG,
    openGood,
    openError,
    setOpenGood,
    setOpenError,
    handleChange,
    guardarDatos,
  };
};
